import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import {
    selectOrganizationBreadcrumb,
    setFirstOrganization,
    setFourthOrganization,
    setSecondOrganization,
    setThirdOrganization,
} from "../features/cms/organizationBreadcrumbSlice";
import { useGetMyUserQuery } from "../gateways/cms/userApi";
import { SelectOrganizationChildren } from "./SelectOrganizationChildren";

export function OrganizationBreadcrumb() {
    const breadcrumb = useSelector(selectOrganizationBreadcrumb);
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const myUser = useGetMyUserQuery();

    const getStorage = (key: string) => {
        if(localStorage.getItem(key)){
            return JSON.parse(localStorage.getItem(key) || "");
        }else{
            return null;
        }
    }

    const setBreadCrumb = (id: string, key: string) => {
        // CLASS1 変更
        if(key === "bc_first"){
            localStorage.removeItem("bc_second");
            localStorage.removeItem("bc_third");
            localStorage.removeItem("bc_fourth");
            if(!id){
                localStorage.removeItem(key);
                localStorage.removeItem("organization_id");
                localStorage.setItem("organization_id", "");
                //localStorage.setItem(key, "");
            }
            dispatch(setFirstOrganization(id));
        // CLASS2 変更
        }else if(key === "bc_second"){
            localStorage.removeItem("bc_third");
            localStorage.removeItem("bc_fourth");
            if(!id){
                localStorage.removeItem(key);
                localStorage.removeItem("organization_id");
                localStorage.setItem("organization_id", (localStorage.getItem("bc_first") || ""));
                //localStorage.setItem(key, (localStorage.getItem("bc_first") || ""));
            }
            dispatch(setSecondOrganization(id));
        }
        // CLASS3 変更
        else if(key === "bc_third"){
            localStorage.removeItem("bc_fourth");
            if(!id){
                localStorage.removeItem(key);
                localStorage.removeItem("organization_id");
                localStorage.setItem("organization_id", (localStorage.getItem("bc_second") || ""));
                //localStorage.setItem(key, (localStorage.getItem("bc_second") || ""));
            }
            dispatch(setThirdOrganization(id));
        }
        // CLASS4 変更
        else if(key === "bc_fourth"){
            if(!id){
                localStorage.removeItem(key);
                localStorage.removeItem("organization_id");
                localStorage.setItem("organization_id", (localStorage.getItem("bc_third") || ""));
                //localStorage.setItem(key, (localStorage.getItem("bc_third") || ""));
            }
            dispatch(setFourthOrganization(id));
        }
        // ローカルストレージに値設定
        if(id){
            localStorage.setItem(key, JSON.stringify(id));
            localStorage.setItem("organization_id", JSON.stringify(id));
        }
        // テナント移動したらページを1に設定
        searchParams.set("page", "1");
        setSearchParams(searchParams);
    }

    // 所属店舗が1つしかないユーザーは、ログイン直後にその店舗を自動選択する
    useEffect(() => {
        const alreadySelected = breadcrumb.first || getStorage("bc_first");
        if (!alreadySelected && myUser.data?.organization.length === 1) {
            setBreadCrumb(String(myUser.data.organization[0].id), "bc_first");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [myUser.data]);

    const disableSecond = () => {
        if(!breadcrumb.first && !getStorage('bc_first')) return true;
        else return false;
    }

    const disableThird = () => {
        if(!breadcrumb.first && !getStorage('bc_first')) return true;
        if(!breadcrumb.second && !getStorage('bc_second')) return true;
        else return false;
    }

    const disableFourth = () => {
        if(!breadcrumb.first && !getStorage('bc_first')) return true;
        if(!breadcrumb.second && !getStorage('bc_second')) return true;
        if(!breadcrumb.third && !getStorage('bc_third')) return true;
        else return false;
    }

    return (
        <>
            <SelectOrganizationChildren
                value={breadcrumb.first || getStorage('bc_first')}
                key="bc_first"
                onChange={(id) => setBreadCrumb(id, "bc_first")}
            />
            <span>&gt;</span>
            <SelectOrganizationChildren
                value={breadcrumb.second || getStorage('bc_second')}
                parent={breadcrumb.first || getStorage('bc_first')}
                disabled={disableSecond()}
                key="bc_second"
                onChange={(id) => setBreadCrumb(id, "bc_second")}
            />
            <span>&gt;</span>
            <SelectOrganizationChildren
                value={breadcrumb.third || getStorage('bc_third')}
                parent={breadcrumb.second || getStorage('bc_second')}
                disabled={disableThird()}
                key="bc_third"
                onChange={(id) => setBreadCrumb(id, "bc_third")}
            />
            <span>&gt;</span>
            <SelectOrganizationChildren
                value={breadcrumb.fourth || getStorage('bc_fourth')}
                parent={breadcrumb.third || getStorage('bc_third')}
                disabled={disableFourth()}
                key="bc_fourth"
                onChange={(id) => setBreadCrumb(id, "bc_fourth")}
            />
            {/* 
            <strong>{breadcrumb.id}</strong>,{breadcrumb.first},{breadcrumb.second},{breadcrumb.third},{breadcrumb.fourth}
             */}
        </>
    );
}
